import { gql } from 'apollo-angular';

import {
  PAYMENT_PURCHASES_OBJECT,
  PURCHASE_INVOICE_OBJECT,
  REFUND_OBJECT,
} from '../../../../@graphql/operations/fragment';

export {
  GET_ALL_PAYMENTS_PURCHASE,
  GET_PURCHASE_PAYMENTS,
} from '../../../../@graphql/operations/query';

export {
  CREATE_PURCHASES_PAYMENTS,
  REMOVE_PURCHASE_PAYMENTS,
  ASSING_PAYMENTS_PURCHASE,
  UPDATE_PAYMENT_PURCHASES_STATUS,
  SEND_PAYMENT_PURCHASE_MAIL,
  REMOVE_PAYMENTS_PURCHASE,
} from '../../../../@graphql/operations/mutation';

export const GET_ALL_AP_PURCHASES = gql`
  query getAllApPurchases($year: Int, $company: String) {
    getAllApPurchases(year: $year, company: $company) {
      ...PurchaseInvoiceObject
    }
  }
  ${PURCHASE_INVOICE_OBJECT}
`;

export const GET_ALL_AP_REFUNDS = gql`
  query getAllApRefunds($year: Int, $company: String) {
    getAllApRefunds(year: $year, company: $company) {
      ...RefundObject
    }
  }
  ${REFUND_OBJECT}
`;

export const GET_ALL_AP_PURCHASEPAYMENTS = gql`
  query getAllApPurchasePayments($year: Int, $company: String) {
    getAllApPurchasePayments(year: $year, company: $company) {
      ...PayPurchasesObject
    }
  }
  ${PAYMENT_PURCHASES_OBJECT}
`;
